module.exports = __webpack_public_path__ + "static/media/wave-header-pattern.7bd77c92.svg";